const getRuntimeEnv = (key: string): string | undefined => {
  const viteEnv = typeof import.meta !== "undefined" ? (import.meta as any).env?.[key] : undefined;
  const nodeEnv = (globalThis as { process?: { env?: Record<string, string | undefined> } }).process?.env?.[key];

  return viteEnv ?? nodeEnv;
};

const getConfiguredCdnBase = (): string | null => {
  const cdnBase = getRuntimeEnv("VITE_AZURE_CDN_BASE_URL") ?? getRuntimeEnv("AZURE_CDN_BASE_URL");
  if (!cdnBase) return null;

  return cdnBase.trim().replace(/\/+$/, "");
};

export const maybeRouteThroughCdn = (url: string): string => {
  const cdnBase = getConfiguredCdnBase();
  if (!cdnBase || !url) return url;

  try {
    const parsed = new URL(url);
    if (!parsed.hostname.endsWith(".blob.core.windows.net")) return url;

    return `${cdnBase}${parsed.pathname}${parsed.search}`;
  } catch {
    return url;
  }
};
